import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_DetectDocumentTextCommand, se_DetectDocumentTextCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class DetectDocumentTextCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Textract", "DetectDocumentText", {})
    .n("TextractClient", "DetectDocumentTextCommand")
    .f(void 0, void 0)
    .ser(se_DetectDocumentTextCommand)
    .de(de_DetectDocumentTextCommand)
    .build() {
}
